import { render, staticRenderFns } from "./TableListUsers.vue?vue&type=template&id=51196885&"
import script from "./TableListUsers.vue?vue&type=script&lang=ts&"
export * from "./TableListUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports